export default __webpack_public_path__ + "static/media/Down.54daf05c.svg";